const handleProductBar = () => {
  const $window = $(window);
  const $header = $('.header');
  const $mainProductForm = $('.js-main-pdp .product__form');
  const $productBar = $('.header__product-bar');

  if ($productBar.length > 0) {
    $window.on('load scroll', function() {
      const headerHeight = $header.outerHeight();
      const isActive = $window.scrollTop() + headerHeight >= $mainProductForm.offset().top + $mainProductForm.outerHeight();

      $productBar.toggleClass('is-active', isActive);
    });
  }
}

handleProductBar();
